<template>
  <main-layout>
    <template #header>
      <main-header :title="'청구서 관리' | translate">
        <template #btn-wrapper>
          <!--          <v-btn
                      small
                      outlined
                      color="primary"
                      @click.stop=""
                    >
                      <v-icon
                        small
                      >
                        mdi-swap-horizontal
                      </v-icon>
                      신규 등록
                    </v-btn>-->
        </template>
      </main-header>
      <search-bar
        v-model="searchOptions.searchKeyword"
        :placeholder="'임대업체 검색' | translate"
        style="width: 450px;"
      />
    </template>

    <template #feature>
      <!--      <v-btn style="padding-left: 0" elevation="0" color="#F9FCFF" @click="openExcelWindow">-->
      <!--        <img :src="utilManager.getImgUrl(IMAGES.EXCEL)">-->
      <!--        엑셀 다운로드-->
      <!--      </v-btn>-->
    </template>

    <template #toolbar>
      <main-toolbar>
        <search-single-select-box
          v-model="searchOptions.actualYn"
          :items="taxYnOptions"
          :label="'실사용자여부' | translate"
          style="max-width: 150px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.useYn"
          :items="usageYnOptions"
          :clearable="false"
          :label="'최종여부' | translate"
          style="max-width: 150px;"
          @update:selected="onFilterChanged"
        />
<!--        <custom-date-picker-->
<!--          v-model="searchOptions.targetMonth"-->
<!--          :picker-type="'month'"-->
<!--          title="정산(매출)월"-->
<!--        />-->
        <custom-date-picker
          v-model="searchOptions.startMonth"
          :picker-type="'month'"
          title="정산(매출)시작월"
        />
        <custom-date-picker
          v-model="searchOptions.endMonth"
          :picker-type="'month'"
          :is-end="true"
          title="정산(매출)종료월"
        />

      </main-toolbar>
    </template>
    <template #summary>
      <div class="d-flex justify-end" style="font-size: small; margin-top: -10px; margin-bottom: 5px">
        총 건수: {{ dataTotalCount }},
        총 요금: {{ numberFormat(summary.resultAmount) }} 원,
        기본요금: {{ numberFormat(summary.baseTotalAmount) }}원,
        계약: {{ numberFormat(summary.contractAmount) }}원,
        모니터링: {{ numberFormat(summary.monitoringAmount) }}원,
        부가서비스: {{ numberFormat(summary.addServiceAmount) }}원
      </div>
    </template>
    <template #body>
      <main-body>
        <infinity-scroll-table
          :headers="headers"
          :is-loading="isLoading"
          :items="convertItems"
          :items-total-count="dataTotalCount"
          :infinity-scroll="infinityScroll"
          :sort-option="sortOption"
          :page-number="searchOptions.pageNumber"
          :page-length="pageLength"
          :item-numbering="true"
          @on-page-change="e => onLoad(e)"
          @on-click-item="e => onClickItem(e)"
          @on-sort-change="onSortChange"
        />

        <v-dialog
          ref="detail-dialog"
          v-model="detailDialogShow"
          width="1200px"
          max-width="1200px"
          persistent
        >
          <mps-usage-detail
            v-if="selectedItem"
            :item="selectedItem"
            :base-plan-list="basePlanList"
            :sub-item-codes="subItemCodes"
            @close="closeDetailDialog"
            @create-billing="onClickCreateBilling"
            @save="onClickSaveUsage"
          />
        </v-dialog>
      </main-body>
    </template>
  </main-layout>
</template>

<script>
import MainLayout from "@/components/common/layout/MainLayout";
import MainBody from "@/components/common/layout/MainBody";
import MainToolbar from "@/components/common/layout/MainToolbar";
import MainHeader from "@/components/common/layout/MainHeader";
import {PATH} from "@/constants";
import TotalCodeOptions from "@/assets/options/TotalCodeOptions";
import SearchSingleSelectBox from "@/components/input/SearchSingleSelectBox";
import SearchBar from "@/components/input/new/SearchBar";
import Headers from "../../components/common/newBase/Headers.vue";
import InfinityScrollTable from "../../components/common/newBase/InfinityScrollTable.vue";
import CustomDatePicker from "../../components/datepicker/CustomDatePicker.vue";
import MpsUsageDetail from "../../components/payment/MpsUsageDetail.vue";

export default {
  name: "MpsUsage",
  components: {
    MpsUsageDetail,
    CustomDatePicker,
    InfinityScrollTable,
    MainToolbar,
    MainHeader,
    MainBody,
    MainLayout,
    SearchBar,
    SearchSingleSelectBox,
  },
  mixins: [TotalCodeOptions, Headers],
  data() {
    return {
      searchOptions: {
        searchKeyword: undefined,
        actualYn: 'Y',
        useYn: 'Y',
        startMonth: this.$now().startOf('month'),
        endMonth: this.$now().endOf('month'),
        targetMonth: this.$now().startOf('month'),
        pageNumber: 1,
        pageSize: 30,
      },
      sortOption: {
        sortBy: ['salesMonth'],
        sortDesc: ['true'],
      },
      // searchOptions: {
      //   useYn: null,
      //   useAutoUsage: null,
      //   useAutoSales: null,
      //   useAutoCms: null,
      //   useAutoTax: null,
      //   cmsUseYn: null,
      //   startDate: null,
      //   endDate: null,
      //   gpCdList: null,
      //   countryCodeList: null,
      //   approvedYn: null,
      //   taxYn: null,
      //   actualYn: 'Y',
      //   rentalcompanyGroups: [],
      // },
      detailDialogShow: false,
      selectedItem: undefined,
      isLoading: false,
      infinityScroll: false,
      dataTotalCount: 0,
      items: [],
      summary: {
        resultAmount:0,
        baseTotalAmount:0,
        contractAmount:0,
        monitoringAmount:0,
        addServiceAmount:0,
      },
      isSummaryLoading: false,
      basePlanList: [],
      subItemCodes: [],
    }
  },

  computed: {
    headers() {
      return this.mpsUsageHeaders
    },
    convertItems() {
      return this.items
    },
    pageLength() {
      if (!this.dataTotalCount) return 1
      return Math.ceil(this.dataTotalCount / this.searchOptions.pageSize)
    },
  },

  watch: {
    'searchOptions.targetMonth': {
      handler(newVal) {
        if (!newVal) return
        this.searchOptions.startMonth = newVal.startOf('month')
        this.searchOptions.endMonth = newVal.endOf('month')
        this.onFilterChanged()
      }
    },
    'searchOptions.startMonth': {
      handler(newVal) {
        if (!newVal) return
        const str = this.$parseDate(newVal)
        const end = this.$parseDate(this.searchOptions.endMonth)

        if (end.diff(str).toObject().milliseconds < 0){
          this.$toasted.info('종료월을 보정합니다.')
          this.searchOptions.endMonth = str.endOf('month')
        } else {
          this.onFilterChanged()
        }
      }
    },
    'searchOptions.endMonth': {
      handler(newVal) {
        if (!newVal) return
        const str = this.$parseDate(this.searchOptions.startMonth)
        const end = this.$parseDate(newVal)

        if (end.diff(str).toObject().milliseconds < 0){
          this.$toasted.info('시작월을 보정합니다.')
          this.searchOptions.startMonth = end.startOf('month')
        } else {
          this.onFilterChanged()
        }
      }
    },
    'searchOptions.searchKeyword': {
      handler(newValue, oldValue) {
        this.onFilterChanged()
      }
    },
  },


  mounted() {
    this.loadTaxYnOptions();
    this.loadBasePlan()
    this.loadCodes()
    this.onLoad(1)
  },

  methods: {
    numberFormat(number){
      if(!number) return '0'
      return Number(number).toLocaleString()
    },
    /**
     * 기본요금제 정보 조회
     * @return {Promise<void>}
     */
    async loadBasePlan(){
      try {
        this.basePlanList.splice(0, this.basePlanList.length)

        const response = await this.$request(PATH.MPS_PLAN.BASE_LIST)
          .setObject({})
          .catch(e => {})
          .enqueue()

        this.basePlanList.push(...response.data)

      } catch (e) {
        console.error(e)
        this.$toasted.error('기본 요금제 정보를 불러오는데 실패했습니다.')
      }
    },

    /**
     * 요금제의 하위 설정 값을 조회
     * @return {Promise<void>}
     */
    async loadCodes() {
      this.subItemCodes.splice(0, this.subItemCodes.length)
      const res = await this.$request(PATH.MPS_PLAN.SUB_CODE_LIST)
        .setObject({})
        .catch(e => {
          console.error(e)
        })
        .enqueue()
      this.subItemCodes.push(...res.data)
    },

    onSortChange(option) {
      Object.keys(option).forEach(e => {
        this.sortOption[e] = option[e]
      })
      this.onFilterChanged()
    },

    /**
     * 필터 변경
     */
    onFilterChanged() {
      this.onLoad(1)
    },

    /**
     * 청구서 조회 호출
     * @param pageNumber
     */
    onLoad(pageNumber) {
      this.loadSummary()
      this.searchOptions.pageNumber = pageNumber
      if (!this.infinityScroll || pageNumber === 1)
        this.items.splice(0, this.items.length)
      this.loadData()
    },


    /**
     * 청구서 목록 조회
     * @return {Promise<void>}
     */
    async loadData() {
      if (this.isLoading) return
      this.isLoading = true
      try {
        const res = await this.$request(PATH.MPS_USAGE.LIST)
          .setObject(
            {...this.searchOptions, ...this.sortOption}
          )
          .catch(e => {
            console.error(e)
          })
          .enqueue()

        this.dataTotalCount = res.dataTotalCount
        this.items.push(...res.data)
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
      }
    },

    async loadSummary() {
      if (this.isSummaryLoading) return
      if (this.isLoading) return
      this.isSummaryLoading = true
      try {
        const res = await this.$request(PATH.MPS_USAGE.SUMMARY)
            .setObject(
                {...this.searchOptions}
            )
            .catch(e => {
              console.error(e)
            })
            .enqueue()

        this.summary = res
        this.isSummaryLoading = false
      } catch (e) {
        this.isSummaryLoading = false
      }
    },


    /**
     * 목록 Item 클릭
     * @param item
     */
    onClickItem(item) {
      this.selectedItem = item
      this.detailDialogShow = true
    },

    /**
     * 상세 다이얼로그 닫기
     */
    closeDetailDialog() {
      this.selectedItem = undefined
      this.detailDialogShow = false
    },

    /**
     * 청구서 정보 저장
     * @param context
     * @return {Promise<void>}
     */
    async onClickSaveUsage(context, isAfterFunc = false) {
      try {
        const res = await this.$request(PATH.MPS_USAGE.REGISTER)
          .setObject(
            context
          )
          .catch(e => {
            console.error(e)
          })
          .enqueue()

        if (!isAfterFunc) {
          if (res){
            this.$toasted.success('저장되었습니다.')
            this.closeDetailDialog()
            this.onLoad(1)
          }
        } else {
          return res
        }
      } catch (e) {
        console.error(e)
      }
    },

    /**
     * 청구서기반 매출 만들기
     * @param context
     * @return {Promise<void>}
     */
    async onClickCreateBilling(context) {
      try {
        let mpsUsageId
        if (this.isDirty(context)){
          mpsUsageId = await this.onClickSaveUsage(context, true)
        } else {
          mpsUsageId = context.mpsUsageId
        }

        if (!mpsUsageId) {
          return this.$toasted.error('청구서에 문제가 있습니다.')
        }

        const param = this.makeBillingParam(context, mpsUsageId)

        //
        const res = await this.$request(PATH.MPS_BILLING.REGISTER)
          .setObject(
            param
          )
          .catch(e => {
            console.error(e)
          })
          .enqueue()
        if(res) {
          this.$toasted.success('저장되었습니다.')
          this.closeDetailDialog()
          this.onLoad(1)
        }
      } catch (e) {
        console.error(e)
      }
    },

    /**
     * 청구서 변경 여부 체크
     * @param context
     * @return {boolean}
     */
    isDirty(context) {
      if (
        !this.selectedItem.mpsUsageId
        || context.baseFee !== this.selectedItem.baseFee
        || context.totalFee !== this.selectedItem.totalFee
        || context.sumAddFee !== this.selectedItem.sumAddFee
        || context.rentalcompanyPlanId !== this.selectedItem.rentalcompanyPlanId
        || context.salesMonth !== this.selectedItem.salesMonth
        || context.usageMonth !== this.selectedItem.usageMonth
        || context.startDate !== this.selectedItem.startDate
        || context.endDate !== this.selectedItem.endDate
      ){
        return true
      }
      let res = false
      context.mpsUsageItems.forEach(e => {
        const fItem = this.selectedItem.mpsUsageItems.find(t => t.rentalcompanyPlanItemId === e.rentalcompanyPlanItemId)
        e.addFee = Number(e.addFee || 0)
        e.usageCnt = Number(e.usageCnt || 0)
        if (
          !fItem
          || e.addFee !== fItem.addFee
          || e.usageCnt !== fItem.usageCnt
        ) {
          res = true
        }
      })

      return res
    },

    /**
     * 매출 Item 만들기
     * @param context
     * @param mpsUsageId
     * @return {{accountId: ([[string],string[]]|*), targetRentalcompanyId, amountAll: *, mpsUsageIds: *[], regDate: *, salesMonth: (string|*), remark: undefined, type: string, billItems: *[]}}
     */
    makeBillingParam(context, mpsUsageId) {
      let param = {
        targetRentalcompanyId: context.rentalcompanyId,
        accountId: context.accountId,
        mpsUsageIds: [ mpsUsageId ],
        type: 'P',
        salesMonth: context.salesMonth,
        billItems: [],
        amountAll: context.totalFee,
        remark: undefined,
        regDate: this.$now().toISO()
      }

      // 기본료
      param.billItems.push({
        itemNm: `${context.planName} 요금제`,
        price: context.baseFee,
        qty: 1,
        uPrice: context.baseFee,
        supplyCost: context.baseFee === 0 ? 0 : context.baseFee - Math.floor(context.baseFee / 10),
        tax: context.baseFee === 0 ? 0 :  Math.floor(context.baseFee / 10),
        remark: `${context.startDate} ~ ${context.endDate}`
      })

      context.mpsUsageItems.forEach(e => {
        if (e.addFee > 0 ) {
          param.billItems.push({
            itemNm: `${e.itemType === 'A' ? '추가' : '부가'}-${e.itemName || ''}`,
            price: e.addFee,
            qty: 1,
            uPrice: e.addFee,
            supplyCost: e.addFee === 0 ? 0 : e.addFee - Math.floor(e.addFee / 10),
            tax: e.addFee === 0 ? 0 : Math.floor(e.addFee / 10),
            remark: `${e.usageCnt} 개`
          })
        }
      })


      return param
    },
  },
}
</script>

<style scoped>
</style>
